"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The GraphQLSliceable is used by the VizPortal explorers and the DC3 grids to make paginated GraphQL queries.
 */
var GraphQLSliceable = /** @class */ (function () {
    function GraphQLSliceable(params, partialQueryVariables, client) {
        this.params = params;
        this.partialQueryVariables = partialQueryVariables;
        this.client = client;
    }
    GraphQLSliceable.prototype.getResultRows = function (listResult, resultData) {
        var _this = this;
        if (listResult && listResult.nodes && listResult.totalCount !== null) {
            return listResult.nodes.map(function (node) { return _this.params.mapResultNode(node, resultData); });
        }
        else {
            return [];
        }
    };
    GraphQLSliceable.prototype.getTotalCount = function (listResult) {
        return listResult ? listResult.totalCount : 0;
    };
    GraphQLSliceable.prototype.getSlice = function (sliceBoundaries) {
        return __awaiter(this, void 0, void 0, function () {
            var variables, apolloQueryResult, resultData, listResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        variables = __assign({}, this.partialQueryVariables, { offset: sliceBoundaries.start, first: sliceBoundaries.size });
                        return [4 /*yield*/, this.client.query({
                                // TODO: remove this cast when updating apollo dependencies (TFS 944332)
                                // This cast is due to the sloppy nature of some of the apollo types not properly addressing the fact that
                                // string values are what are being passed as DocumentNodes which runs perfectly fine until we add graphql types
                                // that specify typing on document nodes.
                                query: this.params.queryGql,
                                variables: variables,
                            })];
                    case 1:
                        apolloQueryResult = _a.sent();
                        resultData = apolloQueryResult.data;
                        listResult = this.params.selectConnectionListResult(resultData);
                        return [2 /*return*/, {
                                items: this.getResultRows(listResult, resultData),
                                totalCount: this.getTotalCount(listResult),
                                // TODO: Revisit the use of this cast when updating graphql/apollo dependencies (types) -- TFS 944332
                                // The following dangerous cast SHOULD be safe so long as the locally GraphQLError type stays in sync
                                // with the types of errors returned by the relationship service
                                errors: apolloQueryResult.errors,
                            }];
                }
            });
        });
    };
    return GraphQLSliceable;
}());
exports.GraphQLSliceable = GraphQLSliceable;
var defaultBlockSize = 1000;
function getAllFromSliceable(sliceable, blockSize) {
    if (blockSize === void 0) { blockSize = defaultBlockSize; }
    return __awaiter(this, void 0, void 0, function () {
        var items, itemsRemaining, slice;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    items = [];
                    itemsRemaining = null;
                    _a.label = 1;
                case 1:
                    if (!(itemsRemaining === null || itemsRemaining > 0)) return [3 /*break*/, 3];
                    return [4 /*yield*/, sliceable.getSlice({ start: items.length, size: blockSize })];
                case 2:
                    slice = _a.sent();
                    items = items.concat(slice.items);
                    itemsRemaining = slice.totalCount - items.length;
                    return [3 /*break*/, 1];
                case 3: return [2 /*return*/, items];
            }
        });
    });
}
exports.getAllFromSliceable = getAllFromSliceable;
function makeRowsForItems(items) {
    return items.map(function (item) { return ({
        key: item.id,
        data: item,
    }); });
}
/**
 * For the Data Catalog grids, we transform the sliceable result into data grid rows.
 * The VizPortal Client explorer code has a different mechanism for doing this transformation.
 */
function makeRowFetcher(sliceableParams, partialQueryVariables, client) {
    var sliceable = new GraphQLSliceable(sliceableParams, partialQueryVariables, client);
    return function queryRows(pageBoundaries) {
        return __awaiter(this, void 0, void 0, function () {
            var start, end, slice;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        start = pageBoundaries.start, end = pageBoundaries.end;
                        return [4 /*yield*/, sliceable.getSlice({ start: start, size: end - start + 1 })];
                    case 1:
                        slice = _a.sent();
                        return [2 /*return*/, {
                                rows: makeRowsForItems(slice.items),
                                totalCount: slice.totalCount,
                                errors: slice.errors,
                            }];
                }
            });
        });
    };
}
exports.makeRowFetcher = makeRowFetcher;
//# sourceMappingURL=GraphQLSliceable.js.map